import useComplexState from '@/lib/utils/useComplexState';
import { v4 as generateUuid } from 'uuid';

const useAggregatedErrorState = (): [
  boolean,
  () => string,
  (errorId: string) => void,
] => {
  const [errorIds, setErrorIds] = useComplexState(new Set<string>());

  const registerError = (): string => {
    const errorId = generateUuid();

    setErrorIds(errorIds => {
      errorIds.add(errorId);
    });

    return errorId;
  };

  const removeError = (errorId: string): void => {
    setErrorIds(errorIds => {
      errorIds.delete(errorId);
    });
  };

  const hasError = errorIds.size > 0;

  return [hasError, registerError, removeError];
};

export default useAggregatedErrorState;
